import SectionHeading from "@/pages/home/components/SectionHeading";
import { characters } from "@/mocks/homeContent";

export default function CharacterSection() {
  return (
    <section id="characters" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="主要人物"
          title="围绕她展开的关系网络"
          desc="作品以女主角的视角出发，人物关系是理解剧情走向的关键。以下按角色在故事中的功能分组介绍。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
          {characters.map((c) => (
            <article
              key={c.role}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5"
            >
              <div className="flex items-center justify-between gap-3">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-2xl text-background-50">
                  <i className={c.icon}></i>
                </span>
                <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900">
                  {c.tag}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                {c.role}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                {c.desc}
              </p>
              <div className="mt-4 flex flex-wrap gap-2">
                {c.traits.map((t) => (
                  <span
                    key={t}
                    className="rounded-full border border-primary-200 bg-primary-50 px-2.5 py-0.5 text-xs text-primary-800"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}